import { IAutocompleteResults, IHit } from '../state-helpers/autocomplete-results';
import * as actions from '../actions/index';
import * as _ from 'lodash';

const defaultAutocompleteResultsModel = Object.freeze({
    hits: [] as IHit[],
    //Using -1 to indicate none selected
    activeHit: -1,
	isActive: false
});


export function autocompleteResultsModel(state: IAutocompleteResults, action: actions.IAutocompleteResultsLoadedAction) {
    if (typeof state === 'undefined') {
        state = defaultAutocompleteResultsModel
    }

    switch (action.type) {
        case actions.ActionType.AUTOCOMPLETE_RESULTS_LOADED:
            return _.assign({}, state, { hits: action.hits});
        case actions.ActionType.AUTOCOMPLETE_ACTIVE_CHANGED:
            return _.assign({}, state, { isActive: action.isActive });
        case actions.ActionType.AUTOCOMPLETE_ACTIVE_HIT_CHANGE:
            return _.assign({}, state, { activeHit: action.activeHit });
        default:
            return state;
    }
}